/* istanbul ignore next */

import { ObjectExtensions, Object } from './Extensions/ObjectExtensions';
export { ObjectExtensions, Object };
import { StringExtensions, String } from './Extensions/StringExtensions';
export { StringExtensions, String };

import { sealed } from './Decorators/SealedDecorator';
export { sealed };

import { SystemTypeHelper } from './Helpers/SystemTypeHelper';
export { SystemTypeHelper };

import { HttpClient } from './HttpClient/HttpClient';
import { IHttpClient, _IHttpClient } from './HttpClient/IHttpClient';
import { IHttpRequestExecutor, _IHttpRequestExecutor } from './HttpClient/IHttpRequestExecutor';
_IHttpClient(); _IHttpRequestExecutor();
export { HttpClient, IHttpClient, IHttpRequestExecutor };

export default ObjectExtensions;